import React from "react";
import {
  DesignDialog,
  DesignDialogButton,
} from "../../common/dashboard/DesignDialog";

export type MemberLoginEmailConflictDialogProps = {
  open: boolean;
  loading: boolean;
  suggestedLoginEmail: string;
  /** The email that the server checked and found in use. */
  checkedLoginEmail?: string;
  onCancel: () => void;
  onUseAlternative: () => void;
};

/**
 * Staff confirmation for an unavailable member-dashboard login. The copy is
 * intentionally limited to the checked address and the server suggestion. It
 * never exposes another member, chamber, or identity owner.
 */
const MemberLoginEmailConflictDialog = ({
  open,
  loading,
  suggestedLoginEmail,
  checkedLoginEmail,
  onCancel,
  onUseAlternative,
}: MemberLoginEmailConflictDialogProps) => (
  <DesignDialog
    open={open}
    title="Member Login Email Is Already In Use"
    message={
      <span>
        {checkedLoginEmail ? (
          <strong className="break-all">{checkedLoginEmail}</strong>
        ) : (
          "This email"
        )}{" "}
        is already used to sign in to a Member Dashboard. To use this
        Administrator email instead, select Use Alternative:
        <span className="mt-4 block break-all rounded-md border border-gray-200 bg-gray-50 px-3 py-2 font-semibold text-gray-950">
          {suggestedLoginEmail}
        </span>
        <span className="mt-4 block">
          Or select Cancel and enter a different Administrator email.
        </span>
      </span>
    }
    icon="email"
    busy={loading}
    onClose={onCancel}
    actions={
      <>
        <DesignDialogButton tone="dark" disabled={loading} onClick={onCancel}>
          Cancel
        </DesignDialogButton>
        <DesignDialogButton disabled={loading} onClick={onUseAlternative}>
          Use Alternative
        </DesignDialogButton>
      </>
    }
  />
);

export default MemberLoginEmailConflictDialog;
